export * from "./regex";
export * from "./validate";
export const progress = [
  { id: 1, name: "Có QĐ chủ trương" },
  { id: 2, name: "Có QĐ giao đất" },
  { id: 3, name: "Đã xác định thuế đất" },
  { id: 4, name: "Khởi công xây dựng" },
  { id: 5, name: "Chuẩn bị mở bán" },
  { id: 6, name: "Xong hầm móng hạ tầng" },
  { id: 7, name: "Xây thô" },
  { id: 8, name: "Cất nóc" },
  { id: 9, name: "Đang hoàn thiện" },
  { id: 10, name: "Hoàn thiện/Bàn giao" },
  { id: 11, name: "Có sổ" },
  { id: 12, name: "Tạm ngừng thi công" },
];
export const business_status = [
  { id: 0, name: "Chưa có kế hoạch" },
  { id: 1, name: "Chưa mở bán" },
  { id: 2, name: "Đang bán" },
  { id: 3, name: "Đã bán hết" },
  { id: 4, name: "Sắp triển khai" },
];
export const document_type = [
  { id: 1, name: "Hợp đồng" },
  { id: 2, name: "Tài liệu marketing" },
  { id: 3, name: "Tờ rơi" },
];
export const document_status = [
  { id: 1, name: "Còn hiệu lực" },
  { id: 2, name: "Đã hết hạn" },
];
